export enum UserStatus {
    Active = "Активен",
    PendingActivation = "Ждет активацию",
    Invited = "Приглашен",
    Blocked = "Заблокирован",
}

export enum UserStatusCode {
    Active = "Active",
    PendingActivation = "PendingActivation",
    Invited = "Invited",
    Blocked = "Blocked",
}